import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AddMasterTempCategoryComponent } from 'src/app/middleware/common/addMasterTempCategory/addMasterTempCategory.component';
import { MasterTemplateCategory } from '../services/settingService/setting.enum';

@Component({
  selector: 'app-manage-templatecategoryorg',
  templateUrl: './manage-templatecategoryorg.component.html',
  styleUrls: ['./manage-templatecategoryorg.component.scss']
})
export class ManageTemplateCategoryOrgComponent implements OnInit { 
  
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;  
  value = '';
  filterText: any;   
  totalCount: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;  
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
  selectedCategoryID:number=0;
  ShowNoRecordFound:boolean=false;
  categoryList: any[] = [];
  masterTemplateList: any[] = [];
  categoryName:string="";
  categoryID:number=0;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('categoryName',this.formBuilder.control(''));    
    this.getCategoryList();
  }

   // For Get All Category List
   getCategoryList(){
    var ReqModel={
      isCategoriesOnly: false,
      isAllTemplate: true,
      categoryID: 0,
      templateType: 2,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId     
    }
     this.loaderService.show();
     this.settingsService.getOrganizationFormTemplateGallery(ReqModel).subscribe(response => {
     if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
              this.categoryList=this.responseHolder.data.categories;
              this.masterTemplateList = this.responseHolder.data.templates;        
              if(this.categoryList.length>0){              
                this.ShowNoRecordFound=false;
             }else{
                this.ShowNoRecordFound=true;
              } 
             }
         }else{
          this.loaderService.hide();
         }
       }else{
        this.loaderService.hide();
       }
     });
   }
   
    //For  Open Pop (Add Category)
     openDialogAdd(templateRef: TemplateRef<any>) {
      this.formDialog.markAsPristine();
      this.formDialog.controls.categoryName.setValue("");
      this.categoryID=0;
      this.dialog.open(templateRef, {
      });
     }

   //For  Open Pop (Update Category)
   openDialogUpdateType(templateRef: TemplateRef<any>, type: any) {
    this.formDialog.markAsPristine();
    this.formDialog.controls.categoryName.setValue(type.name);
   // this.categoryName=type.name;
    this.categoryID=type.categoryID;
    this.dialog.open(templateRef, {
    });
   }
 
    // For Add Category name
    AddCategoryNameDetails(data) {
      this.spinner=true;
      this.formDialog.markAsPristine();   
      var ReqModel = {
          categoryID: 0,//this.categoryID,
          name: data.categoryName.trim(),
          actionType: MasterTemplateCategory.Save,
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),
      }
      this.settingsService.manageFormTemplateOrganizationCategory(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.spinner=false;      
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess){
            this.dialog.closeAll();
            this.getCategoryList();
            this.toastr.success('Category name added successfully.', '', {
              timeOut: 3000,
            });
          }else{
            this.toastr.warning('Category already exist.', '', {
              timeOut: 2000,
            });
            this.spinner=false;         
          }
        }else{
          this.spinner=false;       
        }
      });
     }

   // For Update Category name
   UpdateCategoryNameDetails(data) {
    this.spinner=true;
    this.formDialog.markAsPristine();   
    var ReqModel = {
        categoryID: this.categoryID,
        name: data.categoryName.trim(),
        actionType: MasterTemplateCategory.Rename,
        userId: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeIDList:this.OfficeIDList,
        officeID:this.myOfficeID,
        databaseID: Number(this.databaseId),
    }
    this.settingsService.manageFormTemplateOrganizationCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;      
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess){         
          this.toastr.success('Category name updated successfully.', '', {
            timeOut: 3000,
          });          
          this.getCategoryList();
          this.dialog.closeAll();
        }else{
          this.toastr.warning('Category already exist.', '', {
            timeOut: 2000,
          });
          this.spinner=false;         
        }
      }else{
        this.spinner=false;       
      }
    });
   }

   // For Update Category Status
   UpdateStatus(type: any) {
    this.loaderService.show();
    var ReqModel = {
      categoryID: type.categoryID,
      name: type.name.trim(),
      actionType: MasterTemplateCategory.ChangeStatus,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.manageFormTemplateOrganizationCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getCategoryList();
          this.toastr.success('Category status updated successfully.', '', {
            timeOut: 3000,
          });          
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

   // For Delete Category
   DeleteCategory(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel = {
          categoryID: type.categoryID,
          name: type.name.trim(),
          actionType: MasterTemplateCategory.Delete,
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),
        }     
        this.settingsService.manageFormTemplateOrganizationCategory(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.getCategoryList();
              this.toastr.success('Category deleted successfully.', '', {
                timeOut: 3000,
              });
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }
   

   close() {
    this.dialog.closeAll();
   }


   Search(filterValue) {
    this.filterText = filterValue.trimLeft();
    this.pageModelData.searchValue = filterValue.trim();
   // this.getTypeList(this.pageModelData);
   }

   clearFilter(){
    this.value = "";
    this.filterText = "";
    this.pageModelData.searchValue = this.filterText.trim();
   // this.getTypeList(this.pageModelData);
    }
 


     //For  Open Pop (Add Category)
    //  openDialogForAddCategory() {
    //   const dialogRef = this.dialog.open(AddMasterTempCategoryComponent, {     
    //   });
    //   dialogRef.afterClosed().subscribe(result => {
    //     if(result!=null && result!=undefined){
    //      this.getCategoryList(); 
    //     }
    //   });
    //  }

}
